import { IsBoolean, IsDefined, IsInt, IsNotEmpty, IsOptional, IsString, Length, Matches } from 'class-validator';
import { BaseDto } from '../base.dto';
import {Exclude} from "class-transformer";
import { validationPatterns } from '../../constants';


export class BankingPettyCashCategoryDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantGroupId: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(0, 45)
  @Matches(validationPatterns.nameValidation)
  name: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsDefined()
  @IsBoolean()
  active: boolean;

  @IsOptional()
  @IsInt()
  stockCategoryId?: number;

  @IsOptional()
  @IsInt()
  nominalReportingId?: number;

  @IsDefined()
  @IsBoolean()
  isPos: boolean;

  @IsDefined()
  @IsBoolean()
  isSafe: boolean;

  @IsOptional()
  @Exclude()
  stockCategory?: {
    id: number;
    name: string;
  };
}
